import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

export type Props = {
  ticketId?: number;
  redirectOnNotFound?: boolean;
};

function useGetTicketDetailById({
  ticketId,
  redirectOnNotFound = true
}: Props) {
  const { ticket: ticketApi } = useApiContext();
  const { showApiError } = useGlobalContext();
  const navigate = useNavigate();

  const {
    data: ticket,
    isLoading,
    isError,
    error
  } = useQuery(
    [KEYS.ticket.tickets.detail(ticketId), ticketId],
    () => ticketApi.tickets.detail(ticketId),
    {
      select: (data) => data?.data?.data,
      refetchOnWindowFocus: false,
      enabled: !!ticketId,
      retry: false,
      onError: (error) =>
        showApiError(error, 'Error al cargar el detalle del ticket')
    }
  );

  // Redirigir a la página de búsqueda si no se encuentra el ticket
  useEffect(() => {
    if (redirectOnNotFound && !isLoading && ticketId) {
      // Si la query terminó y no hay ticket, o si hubo un error 404
      if (!ticket || (isError && error?.response?.status === 404)) {
        navigate('/requirement/find');
      }
    }
  }, [
    ticket,
    isLoading,
    isError,
    error,
    ticketId,
    redirectOnNotFound,
    navigate
  ]);

  return {
    ticket,
    isTicketDetailLoading: isLoading
  };
}

export default useGetTicketDetailById;
